import { EpicIcons } from "@constellation-academy/epic-ui";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { type ViewReportButtonProps } from "./view-report-button.types";
import { Button } from "../../../../components/button";
import { Paths } from "../../../../routes/paths";

export const ViewReportButton = ({ reportId }: ViewReportButtonProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	return (
		<Button
			icon={EpicIcons.FILE}
			tooltip={t("reports.viewDetailsTooltip")}
			onClick={() => {
				navigate(Paths.reports.withId(reportId).details.path);
			}}
		/>
	);
};
